import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import ThemeSlice from "./Slices/languageSelectorSlice.js";
import AdminSlice from "../Store/Slices/AdminSlice.js";
import CountrySlice from "./Slices/getCountrySlice.js";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [],
  // whitelist
};
const reducers = combineReducers({
  theme: ThemeSlice,
  store: AdminSlice,
  country: CountrySlice,
});

const persistedReducer = persistReducer(persistConfig, reducers);

// export const store = configureStore({
//    reducer: persistedReducer,
// })

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        ignoredPaths: ["register"],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
